// extracted by mini-css-extract-plugin
export var content = "_qt-1";
export var fullScreen = "_qt-0";